var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tongji-container" },
    [
      _c(
        "el-card",
        { staticClass: "filter-card" },
        [
          _c(
            "el-form",
            {
              staticClass: "form",
              attrs: { inline: true },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "开始日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.startDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "startDate", $$v)
                      },
                      expression: "form.startDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "结束日期" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      placeholder: "选择日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.form.endDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "endDate", $$v)
                      },
                      expression: "form.endDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "button-item", attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleQuery },
                    },
                    [_vm._v(" 查询统计 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "stats-row", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [_vm._v("活跃天数")]),
                _c("div", { staticClass: "stat-value text-primary" }, [
                  _vm._v(_vm._s(_vm.data.activeDays)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v("人均活跃天数"),
                ]),
                _c("div", { staticClass: "stat-value text-success" }, [
                  _vm._v(_vm._s(_vm.data.avgActiveDays) + " 天"),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [_vm._v("打卡次数")]),
                _c("div", { staticClass: "stat-value text-info" }, [
                  _vm._v(_vm._s(_vm.data.counts)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-card", { staticClass: "stat-card" }, [
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v("人均打卡次数"),
                ]),
                _c("div", { staticClass: "stat-value text-warning" }, [
                  _vm._v(_vm._s(_vm.data.avgCounts) + " 次/人"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "chart-row", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "chart-card" }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("span", [_vm._v("PAD每日使用次数")]),
                ]),
                _c("div", {
                  ref: "deviceChart",
                  staticClass: "chart-container",
                  staticStyle: { height: "350px" },
                }),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "chart-card" }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c("span", [_vm._v("PAD每日健康打卡人数")]),
                ]),
                _c("div", {
                  ref: "clockChart",
                  staticClass: "chart-container",
                  staticStyle: { height: "350px" },
                }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "table-card" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("PAD门店每日明细")]),
          ]),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                "show-summary": "",
                "summary-method": _vm.getSummaries,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "entryTime", label: "日期", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店名称",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dayCounts",
                  label: "使用次数",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "dayUsers", label: "打卡人数", align: "center" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "chart-card" }, [
        _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("span", [_vm._v("各门店使用次数对比")]),
        ]),
        _c("div", {
          ref: "totalClockChart",
          staticClass: "chart-container",
          staticStyle: { height: "350px" },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }